import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        primary: '#2196F3',
        accent: '#F2A122'
    }
});
